import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { AngularPaths, Permission } from '@models/index.model';
import { PermissionsService } from '@services/index.service';
import { Observable } from 'rxjs';

export class PermissionGuard {
  static forPermissions(...permissions: Permission[]) {
    @Injectable({providedIn: 'root'})
    class PermissionCheck  {
      constructor(private _permiss: PermissionsService, private _router: Router) {}

      public canActivate(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
      ): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
        if (!this._permiss.hasAllPermiss(...permissions)) {
          // This forces to trigger the DefaultRouteGuard which will redirect the user to the default application route.
          return this._router.parseUrl(AngularPaths.DEFAULT);;
        }
        return true;
      }
    }
    return PermissionCheck;
  }
}
